import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useFeatures } from '@atlassian/jira-navigation-apps-sidebar-next-gen-use-features/src/controllers/features/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { generateNinBasePath } from '../../common/utils/index.tsx';
import type { IssueNavigatorLinkdResponse } from './types.tsx';

export const useIssueNavigatorLink = (): IssueNavigatorLinkdResponse => {
	const { data: projectContextData } = useProjectContext();
	const { data: features } = useFeatures();

	if (
		!projectContextData?.projectType ||
		!projectContextData?.projectKey ||
		typeof projectContextData?.simplified !== 'boolean'
	)
		return { issueNavigatorLink: null };

	const issueNavigatorLink = generateNinBasePath(
		projectContextData.projectKey,
		projectContextData.projectType,
		projectContextData.simplified,
	);

	// Service Desk and Business Projects have Issue Navigator feature permanently on
	let isIssueNavigatoraEnabled = true;

	// Only Jira Software projects have the ability to toggle the Issue Navigator feature
	if (projectContextData.projectType === SOFTWARE_PROJECT) {
		isIssueNavigatoraEnabled = features?.hasSIN || false;
	}

	return { issueNavigatorLink: isIssueNavigatoraEnabled ? issueNavigatorLink : null };
};
